import { render } from "./MenuShow.vue?vue&type=template&id=baa060da"
import script from "./MenuShow.vue?vue&type=script&lang=js"
export * from "./MenuShow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/adrianfraczak/Projects/Actual/GC/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__